export const TEXTS = {
  HELP_CENTER_REPORTS_HINT: 'Хелп-центр',
};
